function formatNumber(
    num: number,
    decimalPlaces: number | undefined,
    symbol: any,
) {
    // 处理数值，保留小数
    const foundedNum = Math.round(num * 100) / 100;
    let formattedNum: string | number = foundedNum;
    if (decimalPlaces && decimalPlaces > 0) {
        // 向后补充0
        formattedNum = foundedNum.toFixed(decimalPlaces);
    } else if (decimalPlaces && decimalPlaces < 0) {
        // 向前补充0
        formattedNum =
            Array(-decimalPlaces - formattedNum.toString().length)
                .fill("0")
                .join("") + formattedNum;
    }

    if (symbol) {
        // symbol处理
        return symbol + formattedNum;
    }
    return formattedNum;
}
// 根据限定范围和前后差值（diff)遍历出一组从小到大的数组
export function difference({
    min,
    max,
    diff,
    decimalPlaces, // 保留几位小数的意思（正数表示往后补，负数表示往前补）
    insertType, // true ? unshift : push
    symbol,
}: {
    min: number;
    max: number;
    diff: number;
    decimalPlaces?: number; // 保留几位小数的意思（正数表示往后补，负数表示往前补）
    insertType?: boolean; // true ? unshift : push
    symbol?: number;
}) {
    let list: (number | string)[] = [];
    for (let i = min; i <= max; i += diff) {
        const res = formatNumber(i, decimalPlaces, symbol);
        // t表示unshift或者是push
        if (insertType) {
            list.unshift(res);
        } else {
            list.push(res);
        }
    }

    return list;
}

// export function getSpecialLensPrice(optionsInfo) {
//   if (!optionsInfo) {
//     return 0;
//   }
//   let options = optionsInfo.find(_item => _item.options_id == 94);
//   if (options && options.options_price) {
//     return options.options_price - 0;
//   }
//   return 0;
// }

// // 镜片价格转换
// export function getLensOptionsPrice(item, optionsInfo) {
//   let _price = optionsInfo.filter(_item => item.optionId == _item.options_id);

//   item.price = _price.length > 0 ? _price[0].options_price - 0 : 0;

//   if (item.childrenList) {
//     item.childrenList.forEach(element => {
//       if (element.optionId) {
//         let element_price = optionsInfo.filter(
//           _item => element.optionId == _item.options_id
//         );
//         element.price =
//           element_price.length > 0 ? element_price[0].options_price - 0 : 0;
//       }
//       if (element.childrenList) {
//         element = getLensOptionsPrice(element, optionsInfo);
//       }
//     });
//   }
//   return item;
// }
